
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.188 4L5 5.625S7 7 7 10.5V22h2V10.5c0-.172-.023-.332-.031-.5H9c0-.367.508-1.617 1.188-2.563.34-.472.699-.886 1-1.156.101-.093.199-.144.28-.187.083.047.177.117.282.218.309.301.68.75 1.031 1.25.352.5.684 1.063.906 1.532.223.469.313.883.313.906v7.219c0 2.261 1.418 4.414 3.719 5.312-.61 1.977-2.477 3.469-4.657 3.469H11v2h2.063c3.128 0 5.792-2.156 6.593-5.063.133.008.239.063.375.063h2.219c2.434 0 4.75-1.832 4.75-4.531 0-1.266-.395-2.434-1.219-3.25-.824-.817-2.02-1.219-3.375-1.219-1.414 0-2.597.57-3.343 1.469-.747.898-1.063 2.054-1.063 3.219V20.5a3.64 3.64 0 01-2-3.281V10c0-.652-.215-1.184-.5-1.781a12.82 12.82 0 00-1.063-1.781c-.406-.583-.84-1.133-1.28-1.563C12.714 4.445 12.37 4 11.5 4c-.809 0-1.21.41-1.656.813-.446.402-.871.902-1.281 1.468-.118.164-.231.332-.344.5C7.387 4.934 6.188 4 6.188 4zm16.218 12c.977 0 1.582.273 1.969.656s.625.938.625 1.813C25 20.043 23.727 21 22.25 21H20v-2.313c0-.792.215-1.48.594-1.937.379-.457.894-.75 1.812-.75z"}})])
          )
        }
      }
    